import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
// Tempo (19.10.2026): Die Stile der nachgeladenen Seiten (siehe App.tsx) bleiben im Haupt-Stylesheet und damit an ihrer alten
// Stelle vor tokens/app/edel/runde2.css. Als eigene Dateien kämen sie später in die Kaskade und würden edel.css und
// runde2.css überschreiben (gemessen: Berichte sahen anders aus).
import "./gespraeche/gespraeche.css";
import "./kontakte/liste/liste.css";
import "./aktivitaeten/aktivitaeten.css";
import "./berichte/berichte.css";
import "./pages/einstellungen/einstellungen.css";
import "./kontakte/kontakte.css";
import "./pages/SmartViews.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-ext-400.css";
import "@fontsource/inter/latin-ext-500.css";
import "@fontsource/inter/latin-ext-600.css";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/edel.css";
import "./styles/runde2.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
